module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
 var rowStyle = "";
 var backgroundSize="";
 var backgroundGradientSize="";
 if (!showNormalLabel) {
     rowStyle = "padding: 0 0 0 15px;";
     backgroundSize="col-md-6";
     backgroundGradientSize="col-md-6";
 }
 else{
     backgroundSize="col-md-4";
     backgroundGradientSize="col-md-5";
 }

 
    ; __append("\r\n ")
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n\r\n<div class=\"row\" style=\"")
    ; __append(escapeFn(rowStyle))
    ; __append("\">\r\n    ")
    ;  if (showNormalLabel) {
    ; __append("\r\n    <div class=\"col-md-3 prop-sublabel\">Normal</div>\r\n    ")
    ;  }
    ; __append("\r\n    <div class=\"")
    ; __append(escapeFn(backgroundSize))
    ; __append(" nopadding\" >\r\n        <input id=\"backgroundColorPicker\" name=\"backgroundColor\" type=\"color\" value=\"")
    ; __append(escapeFn( backgroundColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"backgroundColor\" name=\"backgroundColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( backgroundColor ))
    ; __append("\" />\r\n    </div>\r\n    ")
    ;  if (showGradient) {
    ; __append("\r\n    <div class=\"")
    ; __append(escapeFn(backgroundGradientSize))
    ; __append(" nopadding\" >\r\n        <input id=\"advancedBgGradientColorPicker\" name=\"advancedBgGradientColor\" type=\"color\" value=\"")
    ; __append(escapeFn( advancedBgGradientColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"advancedBgGradientColor\" name=\"advancedBgGradientColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( advancedBgGradientColor ))
    ; __append("\" />\r\n    </div>\r\n    ")
    ;  } else {
    ; __append("\r\n    <div>\r\n        <input type=\"checkbox\" id=\"transparentBackground\" name=\"transparentBackground\" class=\"form-radio-group\" ")
    ; __append(escapeFn( u.isTrue(transparentBackground) ? 'checked' : '' ))
    ; __append("> \r\n        <label class=\"form-group-label\">Transparent</label>\r\n    </div>\r\n    ")
    ;  }
    ; __append("\r\n    \r\n</div>\r\n")
  }
  return __output;

}